// extracted by mini-css-extract-plugin
export default {"header":"header_header__OSTMF","info":"header_info__u1pi-"};